export default __webpack_public_path__ + "static/media/894.2dbffea4.png";